// @ts-check
import './base-map/index.js'
import './text-data/index.js'
import './edit-controls/index.js'
import './map-options/index.js'
import './pdf-viewer/index.js'
import './undo-redo.js'
import './keyboard-editor/index.js'
import { reactiveStore } from './reactive-store.js'
import { FeatureAutosave } from './text-data/feature-autosave.js'
import { JobDataAutosave } from './text-data/job-data-autosave.js'

/** @type {import('./base-map/index.js').BaseMap} BaseMap */

reactiveStore.mapReady.subscribe(() => {
  const features = window['areaData'].map((area) => { /* eslint-disable-line dot-notation */
    /** @type {import('@geoman-io/maplibre-geoman-free').GeoJsonImportFeature} */
    const geojsonFeature = {
      type: 'Feature',
      geometry: area.geometry,
      properties: area.properties
    }
    delete geojsonFeature.properties?.geometry // don't duplicate this in the geojson
    geojsonFeature.properties._id = area.id
    geojsonFeature.properties.reviewed = area.reviewed ? 'Completed' : 'Needs review'
    return geojsonFeature
  })

  // Create polygons for GeoTIFF overlays - to allow editing
  const overlays = window['mapOverlays'] || [] // eslint-disable-line dot-notation
  overlays.forEach((overlay) => {
    const corners = (overlay.ground_control_points || []).map((gcp) => /** @type {[number, number]} */ ([gcp.geo[0], gcp.geo[1]]))
    if (corners.length !== 4) return
    features.push({
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [[corners[0], corners[1], corners[2], corners[3], corners[0]]]
      },
      properties: {
        _id: overlay.storage_path,
        _isMapOverlay: true
      }
    })
  })

  reactiveStore.features.set(features)

  new FeatureAutosave(window['jobId']) // eslint-disable-line dot-notation, no-new
  new JobDataAutosave(window['jobId']) // eslint-disable-line dot-notation, no-new
})
